import videojs from 'video.js';
import initSwiperHeroProduct from '../swipers/swiperHeroProducts';
import initSwiperSingleProjet from '../swipers/swiperSingleProjet';
import initSwiperVideos from '../swipers/swiperVideos';

export default class Players {
    constructor() {
        this.players = [];
        this.currentPlayingPlayer = null;
        this.swiperHeroProduct = null;
        this.swiperSingleProjet = null;
        this.swiperVideos = null;
        this.init();
        this.events();
    }

    events() {
        window.addEventListener('reloadPlayer', () => {
            this.init();
        });
    }

    init() {
        this.initVideoPlayers();
        this.initSwipers();
    }

    initVideoPlayers() {
        const videoElements = document.querySelectorAll('.video-js');

        this.players = Array.from(videoElements).map(videoElement => {
            const player = videojs(videoElement, {
                controls: true,
                autoplay: false,
                preload: 'auto',
                fluid: true,
                controlBar: {
                    playToggle: true,
                    volumePanel: {
                        inline: false
                    },
                    fullscreenToggle: true
                }
            });

            const disableSwiperInteraction = () => this.disableSwiperInteraction();
            const enableSwiperInteraction = () => this.enableSwiperInteraction();

            player.on('play', disableSwiperInteraction);
            player.on('pause', enableSwiperInteraction);
            player.on('ended', enableSwiperInteraction);

            const controlBar = player.controlBar.el();
            controlBar.addEventListener('pointerdown', disableSwiperInteraction);
            controlBar.addEventListener('pointerup', enableSwiperInteraction);
            controlBar.addEventListener('pointercancel', enableSwiperInteraction);
            controlBar.addEventListener('touchstart', disableSwiperInteraction);
            controlBar.addEventListener('touchend', enableSwiperInteraction);

            return player;
        });

        this.players.forEach(player => {
            const slide = player.el().closest('.swiper-slide');
            const slideInner = slide ? slide.querySelector('.swiper-slide_inner') : null;

            player.on('play', () => {
                if (this.currentPlayingPlayer && this.currentPlayingPlayer !== player) {
                    this.currentPlayingPlayer.pause();
                }
                this.currentPlayingPlayer = player;
                if (slideInner) {
                    slideInner.classList.add('playing');
                }
            });
            player.on('pause', () => {
                if (slideInner) {
                    slideInner.classList.remove('playing');
                }
            });
            player.on('ended', () => {
                if (slideInner) {
                    slideInner.classList.remove('playing');
                }
            });
        });
    }

    initSwipers() {
        initSwiperHeroProduct(this);
        initSwiperSingleProjet(this);
        initSwiperVideos(this);
    }

    pauseCurrentVideo = () => {
        if (this.currentPlayingPlayer) {
            this.currentPlayingPlayer.pause();
        }
    }

    removePlayingClass = () => {
        const playingElements = document.querySelectorAll('.swiper-slide_inner.playing');
        playingElements.forEach(element => {
            element.classList.remove('playing');
        });
    }

    disableSwiperInteraction = () => {
        if (this.swiperHeroProduct) {
            this.swiperHeroProduct.allowTouchMove = false;
        }
        if (this.swiperSingleProjet) {
            this.swiperSingleProjet.allowTouchMove = false;
        }
        if (this.swiperVideos) {
            this.swiperVideos.allowTouchMove = false;
        }
    }

    enableSwiperInteraction = () => {
        if (this.swiperHeroProduct) {
            this.swiperHeroProduct.allowTouchMove = true;
        }
        if (this.swiperSingleProjet) {
            this.swiperSingleProjet.allowTouchMove = true;
        }
        if (this.swiperVideos) {
            this.swiperVideos.allowTouchMove = true;
        }
    }
}
